import { Box, Drawer, IconButton, Skeleton } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import Grid from '@mui/material/Grid2';

interface IntegrationsDrawerSkeletonProps {
  open: boolean;
  onClose: () => void;
}

export default function IntegrationsDrawerSkeleton({ open, onClose }: IntegrationsDrawerSkeletonProps) {
  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: '100%', md: '900px' }, p: 3 }
      }}
    >
      {/* Header */}
      <Box display='flex' justifyContent='space-between' alignItems='center' mb={3}>
        <Skeleton variant='text' width={150} height={32} />
        <IconButton onClick={onClose}>
          <IoMdClose />
        </IconButton>
      </Box>

      {/* Integration Cards Grid */}
      <Grid container spacing={3}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Grid key={index} size={{ xs: 12, md: 6 }}>
            <Box
              bgcolor='white'
              p={2}
              border='1px solid #ECECEC'
              borderRadius={2}
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              height='100%'
            >
              {/* Top Section */}
              <Box>
                <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
                  {/* Integration Logo */}
                  <Skeleton variant='rectangular' width={80} height={30} sx={{ borderRadius: 1 }} />
                  {/* Price Badge */}
                  <Skeleton
                    variant='rectangular'
                    width={100}
                    height={28}
                    sx={{
                      borderRadius: '15px',
                      bgcolor: '#dbfcde'
                    }}
                  />
                </Box>

                {/* Description */}
                <Box mb={2}>
                  <Skeleton variant='text' width='100%' height={16} />
                  <Skeleton variant='text' width='90%' height={16} />
                  <Skeleton variant='text' width='80%' height={16} />
                  <Skeleton variant='text' width='70%' height={16} />
                </Box>
              </Box>

              {/* Bottom Section - Reseller Price */}
              <Box mt={2}>
                <Skeleton variant='text' width={100} height={14} sx={{ mb: 0.5 }} />
                <Skeleton variant='text' width={80} height={24} />
                <Skeleton variant='text' width={120} height={14} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Drawer>
  );
}
